<template>
  <div>
    <div class="cart cart--mobile">
      <CartHeader></CartHeader>
      <Cart></Cart>
      <div class="cart__btns">
        <textarea v-model="comment" class="comment" placeholder="Message à l’attention du magasinier"></textarea>
        <CartValid :comment="comment" @success="validCartSuccess"></CartValid>
        <div href="" class="cart__info info">
          <span class="info__total">Total :</span>
          <span class="info__quantity" v-if="total">{{ total }}</span>
          <span class="info__quantity" v-else>0</span>
          <span class="info__quantity-text">produits</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import CartHeader from "@/components/Cart/CartHeader";
import ProductCart from "@/components/Product/ProductCart";
import Cart from "@/components/Cart/Cart";
import CartValid from "@/components/Cart/CartValid";

export default {
  name: "CartPage",
  data() {
    return {
      comment: null
    };
  },
  computed: {
    // Récupération du panier pour afficher le nombre d'items qu'il contient
    total: function() {
      let cart = this.$store.getters["order/getMyCart"];
      let total = 0;
      if(cart && cart.lines && cart.lines.length > 0){
        for(var i = 0; i < cart.lines.length; i++){
          total += cart.lines[i].quantity;
        }
      }
      return total;
    }
  },
  created() {
    this.$store.dispatch('showLoader');
  },
  mounted() {
    let self = this;
    // Permet de relancer une requête au back pour récupérer le panier à jour
    this.$store.dispatch("order/getMyCart").then(function(){
      self.$store.dispatch('hideLoader');
    });
  },
  methods: {
    validCartSuccess() {
      this.comment = null
    }
  },
  components: {
    CartHeader,
    Cart,
    CartValid
  }
};
</script>


<style lang="scss" scoped>
@import "~@/assets/scss/_colors.scss";

::-webkit-scrollbar {
  width: 5px;
  height: 5px;
}

/* Track */
::-webkit-scrollbar-track {
  background: white;
}

/* Handle */
::-webkit-scrollbar-thumb {
  background: $grisclair;
  border-radius: 20px;
  height: 5px;
}

.cart {
  display: flex;

  &--mobile {
    flex-direction: column;

    .cart__btns {
      display: flex;
      flex-wrap: wrap;
      flex-direction: row;
      align-items: flex-end;
      margin-top: 20px;
      width: 100%;
      position: fixed;
      bottom: 0;
      height: 155px;
      z-index: 19;

      .cart__btn {
        width: 50%;
        display: flex;
        flex-wrap: wrap;
        flex-direction: row;
        align-items: center;
        text-align: center;
        justify-content: space-between;
        height: 75px;
        color: white;
        background-color: $vert;
        outline: none;
        border-radius: 0;

        img {
          width: 25px;
          margin-left: 5px;
        }

        span {
          font-size: 12px;
          font-family: 'ClanPro';
        }
      }

      .info {
        width: 50%;
        height: 75px;
        line-height: 70px;
        background-color: white;
        display: flex;
        flex-wrap: wrap;
        flex-direction: row;
        align-items: center;
        text-align: center;
        justify-content: center;

        &__total {
          font-family: 'ClanProBold';
          color: $color1;
          text-transform: uppercase;
          font-size: 12px;
        }

        &__quantity {
          height: 55px;
          width: 55px;
          border-radius: 50%;
          font-family: 'ClanFFBlack';
          font-size: 20px;
          color: $grisfonce;
          border: 1px solid $grisclair;
          text-align: center;
          line-height: 55px;
          margin: 0 10px;
        }

        &__quantity-text {
          color: $grisfonce;
          font-family: 'ClanPro';
          font-size: 12px;
        }
      }
    }

    .imputation__text {
      margin-right: 5px;
    }

    .product {
      .imputation__selector {
        margin-left: 0;
      }
    }
  }

  .comment {
    width: 100%;
    height: 80px;
    border: solid $grisclair;
    border-width: 1px 0 1px 1px;
    padding: 10px;
    font-size: 12px;
  }
}

.left-sidebar {
  width: 300px;

  &__header {
    background-color: $color3;
    display: flex;
    height: 300px;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    img {
      width: 120px;
    }

    span {
      color: white;
      font-family: 'ClanFFBlack';
      font-size: 20px;
      margin-top: 25px;
      text-transform: uppercase;
    }
  }
}

.content-area {
  width: calc(100% - 300px);
  padding: 0 7%;
  margin-top: 80px;
  margin-right: 50px;

  h1 {
    font-family: 'ClanFFBlack';
    color: $color1;
    font-size: 25px;
    margin-bottom: 50px;
    position: relative;
    padding-bottom: 30px;

    &:before {
      content: "";
      display: block;
      width: 60px;
      height: 8px;
      background-color: $color1;
      border-radius: 4px;
      position: absolute;
      bottom: 0;
    }
  }
}

.filters {
  display: flex;
  margin-bottom: 50px;
  width: 80%;

  .filter {
    height: 35px;
    line-height: 35px;
    border: 1px solid $color1;
  }

  input[type=text] {
    width: auto;
    flex: 1;
    padding: 0 15px;
  }
}

form {
  width: 80%;

  label {
    font-family: 'ClanPro';
    color: $color1;
    font-size: 12px;
  }

  .field {
    width: 100%;
    padding: 0 20px;
    height: 50px;
    line-height: 50px;
    font-size: 12px;
    margin-bottom: 20px;
  }

  .field-row {
    display: flex;
    width: 100%;
    justify-content: space-between;
  }

  .field-column {
    width: calc(50% - 10px);
  }

  .submit {
    margin-top: 50px;
    background-color: $vert;
    display: flex;
    padding: 0 20px;
    color: white;
    border: none;
    font-family: 'ClanProBold';
    font-size: 14px;
    height: 70px;
    align-items: center;

    img {
      width: 30px;
      margin-left: 20px;
    }
  }
}


@media screen and (max-width: 1300px) {
  form {
    width: 100%;
  }

  .filters {
    width: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Cart/CartPage.vue